// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as _ from "lodash";
import * as React from "react";
import { TransitionGroup } from "react-transition-group";
import { Icon, Popup } from "semantic-ui-react";
import "./ApplicationMenuAction.less";
import { ApplicationMenuActionItem } from "./ApplicationMenuActionItem";
import { ApplicationFrameContext } from "../ApplicationFrame";
import { getApplicationClassName, getClassName } from "../utils/className";
import { jsx as _jsx } from "react/jsx-runtime";
const className = getApplicationClassName("menu", "action");
export const ApplicationMenuAction = props => {
  const {
    actions
  } = props;
  const [open, setOpen] = React.useState(false);
  const {
    menu
  } = React.useContext(ApplicationFrameContext);
  const handleOpen = React.useCallback(() => {
    React.startTransition(() => {
      setOpen(true);
    });
  }, []);
  const handleClose = React.useCallback(() => {
    React.startTransition(() => {
      setOpen(false);
    });
  }, []);
  return !_.isEmpty(actions) && /*#__PURE__*/_jsx(Popup, {
    on: "hover",
    onOpen: handleOpen,
    onClose: handleClose,
    open: open,
    trigger: /*#__PURE__*/_jsx("div", {
      className: getClassName(className, "item", {
        open
      }),
      children: /*#__PURE__*/_jsx(Icon, {
        name: "add circle",
        size: "large",
        circular: true
      })
    }),
    position: "right center",
    hoverable: true,
    hideOnScroll: true,
    basic: true,
    offset: [0, menu.open ? -295 : 0],
    style: {
      background: "transparent",
      border: "none",
      boxShadow: "none"
    },
    children: /*#__PURE__*/_jsx(TransitionGroup, {
      className: "ui list large horizontal",
      children: _.map(actions, (item, index) => /*#__PURE__*/React.isValidElement(item) ? (
      /*#__PURE__*/
      // eslint-disable-next-line max-len
      React.cloneElement(item, {
        open,
        delay: 60 * (open ? index : actions.length - index)
      })) : /*#__PURE__*/_jsx(ApplicationMenuActionItem, {
        open: open,
        delay: 60 * (open ? index : actions.length - index),
        identifiant: item.identifiant,
        icon: item.icon,
        title: item.title,
        onClick: item.onClick
      }, item.identifiant))
    })
  });
};